module.exports = `<?xml version="1.0" encoding="UTF-8"?>
<svg width="20px" height="20px" viewBox="0 0 20 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 51.1 (57501) - http://www.bohemiancoding.com/sketch -->
    <title>Artboard 9</title>
    <desc>Created with Sketch.</desc>
    <defs></defs>
    <g id="Artboard-9" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
        <g id="-Icon---βeta-/-System-Controls-/-Download-/-1---24-/-3---Blue" transform="translate(-2.000000, -2.000000)" stroke="#0067DB">
            <g id="Download-1" transform="translate(3.000000, 2.000000)">
                <g id="Group-20" transform="translate(0.000000, 0.142090)" stroke-width="1.5">
                    <path d="M17.7501,13.0858406 L17.7501,16.9708406 C17.7501,17.7988406 17.0781,18.4708406 16.2501,18.4708406 L1.7501,18.4708406 C0.9221,18.4708406 0.2501,17.7988406 0.2501,16.9708406 L0.2501,13.0858406" id="Stroke-166"></path>
                    <polyline id="Stroke-168" points="14.5811 9.09564062 9.0001 13.8186406 3.4191 9.09564062"></polyline>
                    <path d="M9.0001,13.6767406 L9.0001,0.970740625" id="Stroke-170"></path>
                </g>
            </g>
        </g>
    </g>
</svg>`;
